export const NAME = "Mon Resto!";
export const HAS_LOGO_APP = true;
export const MENUS_MODULE_ENABLED = true;
export const MENUS_MODULE_IMPORT_SITES = ["*"];
export const ARTICLES_MODULE_ENABLED = true;
export const MEDIAS_MODULE_ENABLED = false;
export const USER_ADD_DB_PRODUCT = false;
export const FEEDBACK_MODULE_ENABLED = false;
